import TakeAway from '@/models/takeAway';

export default () => {
  if (Array.isArray(window.axios.defaults.transformResponse)) {
    return window.axios.defaults.transformResponse.concat((orderStatic: any): any => {
      return {
        totalOrdersCount: Number(orderStatic.totalOrdersCount),
        totalSpent: Number(orderStatic.totalSpent),
        orders: orderStatic.orders.map(TakeAway.createFromRequest),
        staffs: orderStatic.staffs,
      };
    });
  }
};
